/**
 * @created : 2021/3/26
 * @author  : 王冲
 * @desc    : 重登
 */

import { request } from "@weapp/utils";
import { getCookie } from "../utils";
import { publicUrlapi } from "../constants";
import { encryptRsa } from "../utils/encrypt";

//检测冻结
export const checkTenantFrezon = () => {
  return request({
    url: `/papi/app/basicserver/relogin/checkFreezeTenant?tenantKey=${window.TEAMS.currentTenant.tenantKey}`,
    method: "post",
  });
};
//检测离职
export const checkEmpAvaliable = () => {
  return request({
    url: `/papi/app/basicserver/relogin/checkEmpUnvaliable?empId=${window.TEAMS.currentUser.employeeId}`,
    method: "post",
  });
};
//检测离职
export const checkCas = () => {
  return request({
    url: `${(window.weappTenantEnv?.passportUrl || window.TEAMS?.passportUrl)}${publicUrlapi}/relogin`,
    method: "get",
  });
};

//tgt重新获取eteamsid
export const initSession = (tgt: string) => {
  return request({
    url: `/papi/app/basicserver/relogin?tgtId=${tgt}`,
    method: "get",
  });
};

//回写ST
export const initServerTicket = (st: string) => {
  return request({
    url: `/papi/app/basicserver/relogin?serviceTicket=${st}`,
    method: "POST",
  });
};

//获取ST
export const getServerTicket = (data: any) => {
  const formData = new FormData();
  data = encryptRsa(data, 'password');
  for (const key in data) {
    if (Object.prototype.hasOwnProperty.call(data, key)) {
      formData.append(key, data[key]);
    }
  }
  formData.append("langType", getCookie('langType') || 'zh_CN');
  return request({
    url: `${window.weappTenantEnv?.passportUrl || window.TEAMS?.passportUrl}${publicUrlapi}/papi/passport/rest/login`,
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    data: formData
  });
};